// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1kx34","right":"styles_right__23YqE"};